export default "__VITE_ASSET__06d5b9b3__"